import classNames from "classnames";

import { RobotoTypography } from "@/shared/components";
import { EventRecord, EventTopic } from "@/shared/domain/events";
import { EntityIcon } from "@/shared/foundation/icons";

import styles from "./Scopes.module.css";
import { useViewTopic } from "./useViewTopic";

interface SessionEventTopicProps {
  /** The topic and fields displayed in the event's scope. */
  topic: EventTopic;
  /** The event whose start time the workspace seeks to when the topic is opened. */
  event: EventRecord;
}

/**
 * A topic a session event is about, with the fields it names: "/imu
 * (accel.x, accel.y)", or just the topic's name when the event is about all
 * of it.
 */
export function SessionEventTopic({ topic, event }: SessionEventTopicProps) {
  const viewTopic = useViewTopic();
  const label =
    topic.fields === null
      ? topic.topic_name
      : `${topic.topic_name} (${topic.fields
          .map((field) => field.path_in_schema.join("."))
          .join(", ")})`;

  return (
    <span className={styles.container}>
      <EntityIcon type="topic" size="1em" className={styles.icon} />
      <RobotoTypography
        component={"a"}
        className={classNames("ph-no-capture", styles.text, styles.link)}
        onClick={() => viewTopic(topic.topic_name, event)}
        title={label}
      >
        {label}
      </RobotoTypography>
    </span>
  );
}
